import { UserType } from '@/shared/services/user/models';
import { useUserContextStore } from '@/shared/user-context';

import { RouteNames } from '../routeNames';

export function useHomeGuard() {
  const { userType } = useUserContextStore();

  switch (userType) {
    case UserType.TECHNICAL_USER:
      return { name: RouteNames.NOA_SPACE };
    case UserType.FACILITY_ADMIN:
      return { name: RouteNames.VISIBILITY_MANAGEMENT };
    case UserType.CUSTOMER_SUPPORT:
      return { name: RouteNames.API_CLIENTS };
  }

  return true;
}
